import * as React from "react";
import { connect, useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { Box } from "@mui/material";
import Panel from "../../../components/Panel";
import * as NotificationActions from "../../../actions/notification";
import { t, tl } from "../../../components/translate";
import ReferrerCommission from "./ReferrerCommission";
import { clearVendorCommission } from "../../../slices/commission";
import ServiceProviderCommission from "./ServiceProviderCommission";
import { BillDocumentType } from "../../../interfaces/BillInterfaces";
import ReportsPanel from "../../Reports/Panel/ReportsPanel";

export enum Header {
  SERVICE_PROVIDER = "serviceProvider",
  REFERRER = "referrer"
}

interface CommissionPanel {
  handleClose: () => void;
  selectedBill?: BillDocumentType;
  header: Header.REFERRER | Header.SERVICE_PROVIDER;
}

function CommissionPanel({
  handleClose,
  selectedBill,
  header
}: CommissionPanel): React.JSX.Element {
  const dispatch = useDispatch();
  const [selectedHeader, setSelectedHeader] = React.useState<
    Header.REFERRER | Header.SERVICE_PROVIDER
  >(header || Header.SERVICE_PROVIDER);

  React.useEffect(() => {
    dispatch(clearVendorCommission());
  }, [dispatch]);

  return (
    <Panel
      wrapperStyle={{
        zIndex: 1300,
        width: "calc(100vw - 80px)",
        maxWidth: "calc(100vw - 80px)"
      }}
      onClose={handleClose}
      title={t("commission.spCommittionsAndReferrerCharges")}
    >
      <Box sx={{ paddingX: "30px", paddingY: "10px" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}>
          <Box sx={{ display: "flex", gap: "20px", alignItems: "center" }}>
            {(header ? [header] : [Header.SERVICE_PROVIDER, Header.REFERRER]).map((item) => (
              <Box
                sx={{
                  cursor: "pointer",
                  fontSize: "1.2rem",
                  color: selectedHeader === item ? "" : "gray"
                }}
                key={item}
                onClick={() => setSelectedHeader(item)}
              >
                {tl(`commission.${item}`)}
              </Box>
            ))}
          </Box>

          <ReportsPanel
            module="billing"
            showListedReports={["commissionReport"]}
            sxProps={{ zIndex: 1500 }}
          />
        </Box>

        {/* service provider and referrer commissions */}
        {selectedHeader === Header.REFERRER ? (
          <ReferrerCommission selectedBill={selectedBill} />
        ) : (
          <ServiceProviderCommission selectedBill={selectedBill} />
        )}
      </Box>
      <div id="endMarker" />
    </Panel>
  );
}

const mapStateToProps = (state) => ({
  serviceProviders: state.resources.resourceCentreServiceProviders
});

const mapDispatchToProps = (dispatch) => ({
  push: (url) => dispatch(push(url)),
  saveNotification: () =>
    dispatch(
      NotificationActions.notificationAdd({
        id: new Date().getUTCMilliseconds(),
        variant: "success",
        message: "Commission Saved Successfully!",
        autoTimeout: true
      })
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(CommissionPanel);
